import * as React from 'react'
import HomeItemListItem from '../HomeItemListItem/HomeItemListItem'
import TriennialsHomeItemListItem from '../TriennialsSpecial/HomeItemListItem/HomeItemListItem'
import HomeFavourableRoll from '../HomeFavourableRoll/HomeFavourableRoll'
import * as Styles from './HomePictureView.style'
import { deletePictureParams, replaceWkDomain } from '../../../../utils/tools'
import { ImageView } from '../ImageView/ImageView'
import { classes } from 'typestyle'
import { ViewingMonitor, reAssemblyUbt, reportClickEvent } from '@weike/operation-report'
import { reportSetUbt } from '../../../../services/Modules/reportServer'
import { MemberShipAd } from '../../../../plugins/MemberShipAd'
// tslint:disable-next-line
const { LazyLoadImage } = require('react-lazy-load-image-component')

const FAVOURITE_MODULE_CODE = '13'

interface HomePictureViewProp {
  moduleStyle?: string
  invite_id: number
  data: {
    id: number
    name: string
    contents: ItemContents[]
    inviter_id: number
    is_anniversary?: boolean
  }
}

interface ItemContents {
  ad_url?: string
  title?: string
  style_name: string
  cover_urls: CoverUrl[]
}

interface CoverUrl {
  advertisement_url_1: string
  cover_url: string
}

export function HomePictureView(props: HomePictureViewProp) {
  let isAnniversary = false
  const { id } = props.data
  const moduleId = id

  if (props.data.is_anniversary && props.data.is_anniversary === true) {
    isAnniversary = true
  }

  /*
    如果是moduel_style = 2

    那么存在以下情况

    第一项是运营图 后面是

    第一项是双图模式

    所有都是列表项目，没有运营图和双图模式

    运营图夹在中间,最后

    */

  const gotoLink = (url: string, info: { ubt: string; index: number; context: string; url: string }) => {
    reportClickEvent(info.ubt, {
      index: info.index,
      context: info.context,
      url: info.url
    })
    // HACK: add ubt
    const getUbt = reportSetUbt(info.ubt)
    // console.log(info.ubt, getUbt, `${url}&${getUbt}`, props)
    setTimeout(() => {
      window.location.href = `${replaceWkDomain(url)}&${getUbt}`
    }, 150)
  }

  return (
    <>
      <div>
        {isAnniversary && <div className={Styles.activityHeader} />}
        {props.moduleStyle && props.moduleStyle === FAVOURITE_MODULE_CODE && <div className={Styles.FavourableRollHeader} />}
        <div className={Styles.HomePictureViewWrap} style={{ paddingBottom: isAnniversary && 0 }}>
          <div
            className={classes(
              Styles.HomePictureView,
              isAnniversary && Styles.HomePictureViewInActivity,
              props.moduleStyle && props.moduleStyle === FAVOURITE_MODULE_CODE && Styles.FavourableRollWrap
            )}
          >
            {props.moduleStyle !== FAVOURITE_MODULE_CODE && (
              <div className={Styles.titleName} style={{ paddingBottom: isAnniversary && 0, paddingLeft: isAnniversary && 15 }}>
                {props.data.name}
              </div>
            )}

            <div className={Styles.borderWrap}>
              {props.data.contents.map((item: any, index: number) => {
                switch (item.style_name) {
                  case 'advertise':
                    return (
                      <ViewingMonitor
                        key={index}
                        ubt={reAssemblyUbt(`feed__${props.data.id}`)}
                        params={{
                          index,
                          url: item.cover_urls[0].advertisement_url_1,
                          context: props.data.name
                        }}
                      >
                        <div
                          className={classes(Styles.SingleBanner, index === 0 && Styles.firstAd)}
                          onClick={() =>
                            gotoLink(item.cover_urls[0].advertisement_url_1, {
                              ubt: `feed__${props.data.id}`,
                              index,
                              url: item.cover_urls[0].advertisement_url_1,
                              context: props.data.name
                            })
                          }
                          key={index}
                        >
                          <ImageView url={item.cover_urls[0].cover_url} width={700} />
                        </div>
                      </ViewingMonitor>
                    )
                  case 'double_advertise':
                    return (
                      <div className={Styles.indexFeedDoubleBanner} key={index}>
                        {item.cover_urls.map((v: CoverUrl) => {
                          return (
                            <ViewingMonitor
                              ubt={reAssemblyUbt(`feed__${props.data.id}`)}
                              params={{
                                index,
                                url: item.cover_urls[0].advertisement_url_1,
                                context: props.data.name
                              }}
                              key={v.advertisement_url_1}
                            >
                              <div
                                className={Styles.FeedDoubleBannerItem}
                                key={v.cover_url}
                                onClick={() =>
                                  gotoLink(v.advertisement_url_1, {
                                    ubt: `feed__${props.data.id}`,
                                    index,
                                    url: item.cover_urls[0].advertisement_url_1,
                                    context: props.data.name
                                  })
                                }
                              >
                                <ImageView url={v.cover_url} width={700} />
                              </div>
                            </ViewingMonitor>
                          )
                        })}
                      </div>
                    )
                  case 'link_advertise':
                    const { title, ad_url } = item
                    return (
                      <ViewingMonitor
                        ubt={reAssemblyUbt(`feed__${props.data.id}`)}
                        params={{
                          index,
                          url: ad_url,
                          context: props.data.name
                        }}
                      >
                        <div className={Styles.SpecialLink}>
                          <a href={ad_url}>
                            {title}
                            <img className={Styles.SpecialLinkArrow} src="https://static-cos.lycheer.net/picture/12209467_aa3d70834982555801e3546d4f67768c.jpg" />
                          </a>
                        </div>
                      </ViewingMonitor>
                    )
                  default: {
                    if (props.moduleStyle && props.moduleStyle === FAVOURITE_MODULE_CODE) {
                      const isLastIndex = props.data.contents.length === index + 1
                      return <HomeFavourableRoll isLastIndex={isLastIndex} feedName={props.data.name} feed={props.data.id} content={item} index={index} key={index} />
                    }

                    if (isAnniversary) {
                      return <TriennialsHomeItemListItem content={item} key={index} is_anniversary={isAnniversary} invite_id={props.invite_id} />
                    } else {
                      return <HomeItemListItem content={item} key={index} moduleid={moduleId} moduleName={props.data.name} index={index} />
                    }
                  }
                }
              })}
            </div>
          </div>
        </div>
        {props.moduleStyle === '13' && <MemberShipAd />}
      </div>
    </>
  )
}



// WEBPACK FOOTER //
// ./src/views/Home/components/HomePictureView/HomePictureView.tsx